import React from 'react'

const Shimmer = () => {
  return (
    <div className='flex flex-wrap ml-12 text-center md:mx-40'>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>
        <div className='w-32 h-48 bg-gray-200 border rounded-xl m-2'></div>

        
    </div>
  )
}

export default Shimmer